import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface SoundcloudProps {
  band: Band
}

export const Soundcloud: React.FC<SoundcloudProps> = ({ band }) => {
  const fieldData = {
    field: "soundcloud_url",
    name: "soundcloud",
    label: "Your Soundcloud URL",
    placeholder: "Soundcloud URL",
    notes:
      "Link your profile to Soundcloud. Your url should look like https://soundcloud.com/theblackblack",
    required: false,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
